<ul class="menu-wrapper menu-vertical-tree" [class.menu-vertical-tree-children]="isChild">
  <ng-container *ngFor="let item of nodes">
    <ng-container *appHasLicenseModule="item.modules">
      <li *appHasRole="item.roles">
        <div class="menu-item" [class.active]="isActiveRoute(item)">
          <a class="menu-item-link" [routerLink]="item.link">
            <span [ngClass]="item.icon"></span> {{ item.name }}
          </a>

          <span
            *ngIf="item.children && item.children.length"
            class="menu-item-expander fas"
            [class.fa-chevron-up]="item.isExpanded"
            [class.fa-chevron-down]="!item.isExpanded"
            (click)="onToggle(item)"
          ></span>
        </div>

        <app-menu-vertical-tree
          *ngIf="item.children && item.children.length && item.isExpanded"
          [nodes]="item.children"
          [isChild]="true"
        ></app-menu-vertical-tree>
      </li>
    </ng-container>
  </ng-container>
</ul>
